import type { components } from '../api/types';
import { webSocket } from 'rxjs/webSocket';
import { LoginStatus, loginStatus$ } from '../store/loginV2';
import { map, switchMap, take, tap } from 'rxjs';

export type NewPresentationSettings =
    components['schemas']['NewPresentationSettings'];

interface CreateMessage {
    type?: undefined;
    action: 'create';
    payload: NewPresentationSettings;
}
interface ProgressMessage {
    type: 'progress';
    message: string;
}
interface CompleteMessage {
    type: 'complete';
    url: string;
}

interface ErrorMessage {
    type: 'error';
    message: string;
}
type Message = ProgressMessage | CompleteMessage | CreateMessage | ErrorMessage;

function getWebsocketUrl(token: string) {
    const isSecure = /https/.test(window.location.protocol);
    return `ws${isSecure ? 's' : ''}://${window.location.hostname}:${
        window.location.port
    }/presentation?jwt=${token}`;
}

export function createNewPresentation(settings: NewPresentationSettings) {
    return loginStatus$.pipe(
        take(1),
        map((status) => {
            if (status.status !== LoginStatus.LOGGED_IN) {
                throw new Error('User is not logged in!');
            }
            return status.token;
        }),
        switchMap((token) => {
            const url = getWebsocketUrl(token);

            const socket = webSocket<Message>(url);
            socket.next({
                action: 'create',
                payload: settings,
            });
            return socket.pipe(
                tap((msg) => {
                    if (msg.type === 'complete') {
                        socket.complete();
                    }
                })
            );
        })
    );
}
